/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
import 'resources/less/themes/base/widgets/popup.less';

import _ from 'underscore';
import backbone from 'backbone';
import screen from 'assets/js/modules/screen';

var DIALOG_POPUP_PREFIX = 'dialog-popup';

var Popup = function($el, options) {
    var _this = this;
    this.$el = $el;
    options = options || {};

    _.extend(this, backbone.Events);

    this.listenTo(this, {
        open: function() {
            if (_.isFunction(options.open)) {
                options.open();
            }
        },
        close: function() {
            if (_.isFunction(options.beforeClose)) {
                options.beforeClose();
            }
            if (_.isFunction(options.close)) {
                options.close();
            }
        }
    });

    this._createDomElement(options);

    this.$el.find(this._getDialogMaskSelector()).on('click', function(e) {
        if ($(e.target).is(_this._getDialogMaskSelector())) {
            _this.close();
        }
    });

    this.$el.find(this._getDialogToolbarCloseSelector()).on('click', function() {
        _this.close();
    });

    this.$el.find(this._getDialogBodySelector()).css({
        width: this._getWidth(options.width),
        height: options.height,
        minHeight: options.minHeight,
        maxHeight: options.maxHeight
    });
};

Popup.prototype = {
    open: function() {
        this.$el.removeClass('hidden');
        this.$el.removeAttr('hidden');
        this.trigger('open');
    },

    close: function() {
        this.$el.addClass('hidden');
        this.$el.attr('hidden', 'true');
        this.trigger('close');
    },

    destroy: function() {
        this.$el.remove();
    },

    /**
     * @param {string} content
     */
    setContent: function(content) {
        this.$el.find(this._getDialogBodySelector()).html(content);
        this.trigger('contentUpdated');
    },

    /**
     * @param {string} title
     */
    setTitle: function(title) {
        this.$el.find(this._getDialogHeaderTitleSelector()).html(title);
    },

    /**
     * @param {string} className
     */
    removeClass: function(className) {
        this.$el.removeClass(className);
    },

    /**
     * @param {string} className
     */
    addClass: function(className) {
        this.$el.addClass(className);
    },

    /**
     * @param {string} value
     */
    setHeight: function(value) {
        this.$el.find(this._getDialogBodySelector()).css({
            height: value
        });
    },

    /**
     * @returns {number} value
     */
    getHeight: function() {
        return this.$el.find(this._getDialogBodySelector()).height();
    },

    /**
     * @returns {number} value
     */
    getContainerHeight: function() {
        return this.$el.find(this._getDialogContainerSelector()).height();
    },

    setIsLoading: function() {
        this.$el
            .find(this._getDialogContainerSelector())
            .find(' > div')
            .hide();
        this.$el.find(this._getDialogContainerSelector()).addClass('loading');
    },

    removeIsLoading: function() {
        this.$el.find(this._getDialogContainerSelector()).removeClass('loading');
        this.$el
            .find(this._getDialogContainerSelector())
            .find(' > div')
            .show();
    },

    /**
     * @param {string} selector
     * @returns {jQuery}
     */
    find(selector) {
        return this.$el.find(selector);
    },

    /**
     * @param {number} width
     * @return {number}
     * @private
     */
    _getWidth: function(width) {
        // width should not extend the screen width
        var maxWidth = screen.getWidth() - 20;
        if (width && width > maxWidth) {
            return maxWidth;
        }

        return width;
    },

    /**
     * @param {object} options
     * @private
     */
    _createDomElement: function(options) {
        var popupClass = DIALOG_POPUP_PREFIX + ' hidden';
        if (options.dialogClass) {
            popupClass += ' ' + options.dialogClass;
        }
        this.$el.addClass(popupClass).appendTo($('body'));

        if (this.$el.html() !== '') {
            options.content = this.$el.html();
        }
        if (this.$el.data('title') !== undefined) {
            options.title = this.$el.data('title');
        }
        if (this.$el.data('footer') !== undefined) {
            options.footer = this.$el.data('footer');
        }
        this.$el.appendTo('body');

        var template = _.template(
            [
                '<div class="<%= dialogMaskClass %>">' +
                    '<div class="<%= dialogContainerClass %>">' +
                    '<div class="<%= dialogHeaderClass %>">' +
                    '<p class="<%= dialogHeaderTitleSelector %>"><%= title %></p>' +
                    '<div class="<%= dialogToolbarClass %>">' +
                    '<div class="<%= dialogToolbarCloseClass %>" title="<%= closeText %>"></div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="<%= dialogBodyClass %>">' +
                    '<%= content %>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
            ].join('')
        );

        this.$el.html(
            template({
                closeText: options.closeText,
                title: options.title,
                content: options.content,
                dialogMaskClass: this._getDialogMaskClass(),
                dialogContainerClass: this._getDialogContainerClass(),
                dialogToolbarClass: this._getDialogToolbarClass(),
                dialogToolbarCloseClass: this._getDialogToolbarCloseClass(),
                dialogHeaderClass: this._getDialogHeaderClass(),
                dialogHeaderTitleSelector: this._getDialogHeaderTitleClass(),
                dialogBodyClass: this._getDialogBodyClass()
            })
        );
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogMaskSelector: function() {
        return '.' + this._getDialogMaskClass();
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogMaskClass: function() {
        return DIALOG_POPUP_PREFIX + '-mask';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogToolbarClass: function() {
        return DIALOG_POPUP_PREFIX + '-toolbar';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogToolbarCloseSelector: function() {
        return '.' + this._getDialogToolbarCloseClass();
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogToolbarCloseClass: function() {
        return DIALOG_POPUP_PREFIX + '-toolbar-close';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogContainerSelector: function() {
        return '.' + this._getDialogContainerClass();
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogContainerClass: function() {
        return DIALOG_POPUP_PREFIX + '-container';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogBodySelector: function() {
        return '.' + this._getDialogBodyClass();
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogBodyClass: function() {
        return DIALOG_POPUP_PREFIX + '-body';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogHeaderClass: function() {
        return DIALOG_POPUP_PREFIX + '-header';
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogHeaderTitleSelector: function() {
        return '.' + this._getDialogHeaderTitleClass();
    },

    /**
     * @returns {string}
     * @private
     */
    _getDialogHeaderTitleClass: function() {
        return DIALOG_POPUP_PREFIX + '-header-title';
    }
};

export default Popup;
